import React, { useState } from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { Doughnut } from 'react-chartjs-2';
import { euroFormat } from '../../helpers/functions';
import PopupTable from '../../components/PopupTable';
import Axios from 'axios';
import { meekroDB } from '../../config';

// 1. IMPORTER LE PLUGIN DATALABELS
import ChartDataLabels from 'chartjs-plugin-datalabels';

const VenteParTarifs = ({ analyseCaTranche, analyseCaTarif, getFilter }) => {
    // console.log(analyseCaTarif);
    const theme = createMuiTheme({
        palette: {
            primary: blue,
        },
        typography: {
            fontFamily: 'Arial, sans-serif',
        },
    });


    const [columnsData, setColumnsData] = useState(null);
    const [title, setTitle] = useState(null);
    const [data, setData] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);

    const handleTarifClick = (segmentData) => {

        Axios.post(`${meekroDB}/analyse/analyse_ca.php?action=analyse_1_tarif&tarif=${segmentData.id_tarif}`, getFilter())
            .then(response => {
                const columnsTranche = [
                    { title: 'Ref', field: 'ref', align: 'center', type: "numeric" },
                    { title: 'Designation', field: 'designation', align: 'center' },
                    { title: 'Vente HT', field: 'totht', type: "numeric", align: 'center', render: rowData => euroFormat(rowData.totht) },
                    { title: 'Client', field: 'Nom_agence', align: 'center' },
                    { title: 'Tarif', field: 'tarif', align: 'center' },
                ];
                setColumnsData(columnsTranche);
                setTitle(`Détail Tarif : ${segmentData.tarif}`);
                setData(response.data);

                console.log(data);
                setPopupOpen(true); // Ouvrez la popup
            })
            .catch(error => {
                console.log(error);
            });

    };

    const handleTrancheClick = (segmentData) => {
        let min, max;
        const { intervalle_ca_ht } = segmentData;
        if (intervalle_ca_ht.includes("à")) {
            const segmentParts = intervalle_ca_ht.split(" à ");
            min = segmentParts[0];
            max = segmentParts[1];
        } else if (intervalle_ca_ht.startsWith(">")) {
            min = intervalle_ca_ht.substring(1); // Supprime le caractère ">"
            max = 100000000;
        } else if (intervalle_ca_ht === "0") {
            min = 0;
            max = 0;
        }
        Axios.post(`${meekroDB}/analyse/analyse_ca.php?action=analyse_1_tranche&min=${min}&max=${max}`, getFilter())
            .then(response => {
                const columnsTranche = [
                    { title: 'Ref', field: 'ref', align: 'center', type: "numeric" },
                    { title: 'Designation', field: 'designation', align: 'center' },
                    { title: 'Vente HT', field: 'totht', type: "numeric", align: 'center', render: rowData => euroFormat(rowData.totht) },
                    { title: 'Client', field: 'Nom_agence', align: 'center' },
                ];
                setColumnsData(columnsTranche);
                setTitle(`Détail  Tranche Prix : ${segmentData.intervalle_ca_ht} €`);
                setData(response.data);

                console.log(data);
                setPopupOpen(true); // Ouvrez la popup
            })
            .catch(error => {
                console.log(error);
            });

    };


    const totalHT = euroFormat(analyseCaTranche.reduce((total, item) => total + parseInt(item.total_ca_ht), 0));

    // LABELS NETTOYÉS
    const doughnutTranche = {
        labels: analyseCaTranche.map(item => item.intervalle_ca_ht),
        datasets: [{
            data: analyseCaTranche.map(item => parseInt(item.total_ca_ht)),
            // 2. AJOUTER LA PROPRIÉTÉ POUR LE PLUGIN
            qte: analyseCaTranche.map(item => item.Qte || 0),
            backgroundColor: [
                'rgba(255, 99, 132, 0.7)',
                'rgba(54, 162, 235, 0.7)',
                'rgba(255, 206, 86, 0.7)',
                'rgba(240, 10, 10, 0.7)',
                'rgba(120, 206, 10, 0.7)',
            ],
        }],
    };

    // LABELS NETTOYÉS
    const doughnutTarif = {
        labels: analyseCaTarif.map(item => item.tarif),
        datasets: [{
            data: analyseCaTarif.map(item => parseInt(item.total_ca_ht)),
            // 2. AJOUTER LA PROPRIÉTÉ POUR LE PLUGIN
            qte: analyseCaTarif.map(item => item.Qte || 0),
            backgroundColor: [
                'rgba(255, 99, 132, 0.7)',
                'rgba(255, 206, 86, 0.7)',
                'rgba(54, 162, 235, 0.7)',
                'rgba(240, 10, 10, 0.7)',
                'rgba(120, 206, 10, 0.7)',
            ],
        }],
    };

    // 3. CONFIGURATION GÉNÉRALE DU PLUGIN DATALABELS (Chart.js 2.x -> sous options.plugins)
    const datalabelsConfig = {
        plugins: {
            datalabels: {
                color: '#fff',
                anchor: 'center',
                align: 'center',
                formatter: (value, context) => {
                    const qte = context.dataset.qte[context.dataIndex];
                    return (qte ?? 0).toString();
                },
                font: {
                    weight: 'bold',
                    size: 14,
                },
            }
        }
    };

    // --- Options Tranches ---
    const options = {
        // AJOUTER LA CONFIGURATION DU PLUGIN
    ...datalabelsConfig,
        legend: {
            display: true,
            position: 'right',
            onClick: () => { },
            labels: {
                fontSize: 16,
                // On utilise toujours generateLabels pour le titre et le formatage euro du CA
                generateLabels: function (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const ds = data.datasets[0];
                        const legendLabels = [];

                        const titreLegend = `Ventes HT : ${totalHT}`;
                        legendLabels.push({
                            text: titreLegend,
                            fillStyle: 'transparent',
                            lineWidth: 0,
                            index: -1
                        });
                        legendLabels.push({
                            text: "",
                            fillStyle: 'transparent',
                            lineWidth: 0,
                            index: -2
                        });

                        // Détails pour chaque segment
                        data.labels.forEach((label, i) => {
                            const montantHT = analyseCaTranche[i].total_ca_ht;
                            legendLabels.push({
                                text: `${label} (${euroFormat(montantHT)})`,
                                fillStyle: ds.backgroundColor[i],
                                hidden: isNaN(ds.data[i]) || chart.getDatasetMeta(0).data[i].hidden,
                                index: i
                            });
                        });

                        return legendLabels;
                    } else {
                        return [];
                    }
                }
            }
        },
        tooltips: {
            enabled: true,
            callbacks: {
                title: function (items, chartData) {
                    if (!items || !items.length) return '';
                    const label = chartData.labels[items[0].index] || '';
                    return label; // déjà propre (intervalle)
                },
                label: function (tooltipItem, chartData) {
                    const idx = tooltipItem.index;
                    const ds = chartData.datasets[tooltipItem.datasetIndex];
                    const value = ds.data[idx] || 0;
                    const qte = ds.qte ? ds.qte[idx] : (analyseCaTranche[idx]?.Qte || 0);
                    const total = ds.data.reduce((a, b) => a + b, 0) || 0;
                    const pct = total ? (value / total * 100).toFixed(1) : '0.0';
                    return [
                        `CA: ${euroFormat(value)}`,
                        `Qté: ${qte}`,
                        `Part: ${pct}%`
                    ];
                }
            }
        }
    };

    // --- Options Tarifs ---
    const optionsPrixR = {
        // AJOUTER LA CONFIGURATION DU PLUGIN
    ...datalabelsConfig,
        legend: {
            display: true,
            position: 'right',
            onClick: () => { },
            labels: {
                fontSize: 16,
                generateLabels: function (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const ds = data.datasets[0];
                        const legendLabels = [];

                        const titreLegend = `Types Tarif`;
                        legendLabels.push({
                            text: titreLegend,
                            fillStyle: 'transparent',
                            lineWidth: 0,
                            index: -1
                        });
                        legendLabels.push({
                            text: "",
                            fillStyle: 'transparent',
                            lineWidth: 0,
                            index: -2
                        });

                        data.labels.forEach((label, i) => {
                            const montantHTparTarif = analyseCaTarif[i].total_ca_ht;

                            legendLabels.push({
                                text: `${label} (${euroFormat(montantHTparTarif)})`,
                                fillStyle: ds.backgroundColor[i],
                                hidden: isNaN(ds.data[i]) || chart.getDatasetMeta(0).data[i].hidden,
                                index: i
                            });
                        });

                        return legendLabels;
                    } else {
                        return [];
                    }
                }
            }
        },
        tooltips: {
            enabled: true,
            callbacks: {
                title: function (items, chartData) {
                    if (!items || !items.length) return '';
                    const label = chartData.labels[items[0].index] || '';
                    return label; // tarif
                },
                label: function (tooltipItem, chartData) {
                    const idx = tooltipItem.index;
                    const ds = chartData.datasets[tooltipItem.datasetIndex];
                    const value = ds.data[idx] || 0;
                    const qte = ds.qte ? ds.qte[idx] : (analyseCaTarif[idx]?.Qte || 0);
                    const total = ds.data.reduce((a, b) => a + b, 0) || 0;
                    const pct = total ? (value / total * 100).toFixed(1) : '0.0';
                    return [
                        `CA: ${euroFormat(value)}`,
                        `Qté: ${qte}`,
                        `Part: ${pct}%`
                    ];
                }
            }
        }
    };

    return (

        <MuiThemeProvider theme={theme}>
            <div className="row">
                <div className="col-6">
                    {/* 4. PASSER LE PLUGIN AU COMPOSANT DOUGHNUT */}
                    <Doughnut data={doughnutTranche} options={options} plugins={[ChartDataLabels]} getElementAtEvent={(elems) => {
                        if (elems.length > 0) {
                            const segmentIndex = elems[0]._index;
                            const segmentData = analyseCaTranche[segmentIndex];
                            handleTrancheClick(segmentData);
                        }
                    }}
                    />
                </div>
                <div className="col-6">
                    {/* 4. PASSER LE PLUGIN AU COMPOSANT DOUGHNUT */}
                    <Doughnut data={doughnutTarif} options={optionsPrixR} plugins={[ChartDataLabels]} getElementAtEvent={(elems) => {
                        if (elems.length > 0) {
                            const segmentIndex = elems[0]._index;
                            const segmentData = analyseCaTarif[segmentIndex];
                            handleTarifClick(segmentData);
                        }
                    }}
                    />
                </div>
            </div>
            <PopupTable
                open={popupOpen}
                handleClose={() => setPopupOpen(false)}
                columns={columnsData}
                title={title}
                data={data}
            />
        </MuiThemeProvider>
    );

};

// 5. Enregistrer le plugin globalement (souvent fait ici pour être sûr)
// NOTE: Avec 'react-chartjs-2', le passer via la prop `plugins` est souvent suffisant.
// Chart.register(ChartDataLabels); 

export default VenteParTarifs;